import collaborateImage from 'marketing-website/media/images/pages/consultancies/collaborate@2x.jpg';
import democratiseImage from 'marketing-website/media/images/pages/consultancies/democratise@2x.jpg';
import feedbackImage from 'marketing-website/media/images/pages/consultancies/feedback@2x.jpg';
import hero from 'marketing-website/media/images/pages/consultancies/hero@2x.jpg';
import validateImage from 'marketing-website/media/images/pages/consultancies/validate@2x.jpg';
import scaleImage from 'marketing-website/media/images/pages/consultancies/scale@2x.jpg';
import sharePreview from 'marketing-website/media/images/pages/enterprise/ogPreview.png';

const assets = {
  hero: {
    alt: 'Drive digital transformation through innovative design',
    src: hero,
    maxWidth: 660,
  },
  democratise: {
    alt: 'Democratise design by giving every team access to the right tools',
    src: democratiseImage,
    maxWidth: 660,
  },
  feedback: {
    alt: 'Get buy-in early on with feedback loops reduced to minutes, not days',
    src: feedbackImage,
    maxWidth: 660,
  },
  collaborate: {
    alt: 'Co-creation tools that turn clients into collaborators',
    src: collaborateImage,
    maxWidth: 600,
  },
  validate: {
    alt: 'Validate ideas at speed with user testing',
    src: validateImage,
    maxWidth: 1000,
  },
  scale: {
    alt: 'Democratise design and drive digital transformation',
    src: scaleImage,
    maxWidth: 660,
  },
  sharePreview: {
    src: sharePreview,
    maxWidth: 1200,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/consultancies/assets.js